module.exports = __webpack_public_path__ + "static/media/xfzj.a00a40b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xfzj.png
// module id = 690
// module chunks = 0 1